<h1 mat-dialog-title>Import Errors</h1>
  <div mat-dialog-content>
    <p>The following errors were encountered</p>
    <p><b>All other lines have been imported</b></p>

    <div style="margin-top: 10px;">
      <div *ngFor="let error of errors">
        <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
          <div fxFlex="20">
            {{error.rowNr}}
          </div>
          <div fxFlex>
            {{error.errorMessage}}
          </div>
      </div>
    </div>

  </div>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="onCloseClick()">
      <a>Close</a>
    </button>
  </div>
</div>
